import React, { useContext, useEffect, useState } from "react";
import api, { attendantLaravelApi } from "./services/api";
import { WidgetContext } from "./contexts/widgetContext";
import { CustomThemeProvider } from "./contexts/themeContext";

import Webphone from "./components/v2/layout/main";
import Router from "./Router";
import ReceivingCall from "./components/v2/receiving-call";
import { RouterContext } from "./contexts/routerContext";

function App() {
  const [outputAudio, setOutput] = useState(false);
  const { setRouter } = useContext(RouterContext);
  const {
    showReceivingCall,
    setShowReceivingCall,
    stack,
    setStack,
    interationSIP,
    setInterationSIP,
    callInProgress,
    setCallInProgress,
    seconds,
    minutes,
    hours,
    start,
    pause,
    reset,
    timer,
    setTimer,
    setContact,
    setMute,
  } = useContext(WidgetContext);

  let BCSIP = window.BCSIP;
  let stacking;

  const startStack = async () => {
    return new Promise((resolve, reject) => {
      BCSIP.ready(function () {
        stacking = BCSIP.createStack();
        stacking.connect();

        setStack(stacking);
        startEventStackListeners();
        resolve(true);
      });
    });
  };

  useEffect(() => {
    setContact(undefined);
    setTimer(
      `${hours < 10 ? "0" + hours : hours}:${
        minutes < 10 ? "0" + minutes : minutes
      }:${seconds < 10 ? "0" + seconds : seconds}`
    );
    if (callInProgress.answered_call === "SIM") {
      setCallInProgress({
        type: callInProgress.type,
        number: callInProgress.number,
        time: timer,
        status: callInProgress.status,
        answered_call: callInProgress.answered_call,
      });

      localStorage.setItem(
        "@WEBPHONE.CALLINPROGRESS",
        JSON.stringify({
          type: callInProgress.type,
          number: callInProgress.number,
          time: timer,
          status: callInProgress.status,
          answered_call: callInProgress.answered_call,
        })
      );
    }
  }, [seconds]);

  useEffect(() => {
    startStack();
  }, []);

  const setDriversAudioAndVideo = async () => {
    navigator.mediaDevices.getUserMedia({ audio: true });
    const driverMicrofone = localStorage.getItem("@WebphoneMicrofone");
    const driverVolume = localStorage.getItem("@WebphoneVolume");
    const driverVolumeRing = localStorage.getItem("@WebphoneRing");
    const currentSound = localStorage.getItem("@WebphoneCurrentSound");

    if (driverVolume) {
      document.getElementById("audio_remote").setSinkId(driverVolume);
    }

    if (currentSound && document.getElementById("webphone-audio")) {
      document.getElementById("webphone-audio").setSinkId(driverVolumeRing);
      document.getElementById("webphone-audio").src = `sounds/${currentSound}`;
    }

    if (driverVolumeRing) {
      document.getElementById("ringtone").setSinkId(driverVolumeRing);
      document.getElementById("ringtone").src = `sounds/${currentSound}`;
    }
  };

  const remoteAudio = document.getElementById("audio_remote");
  if (remoteAudio && !outputAudio) {
    setOutput(true);
    setDriversAudioAndVideo();
  }

  /** Eventos SIP */
  let activeCall;

  let startEventSessionListeners = () => {
    let sessionStack;
    if (!stack) {
      sessionStack = stacking;
    } else {
      sessionStack = stack;
    }
    sessionStack.eventSession.on("connecting", () => {});

    sessionStack.eventSession.on("i_ao_request", () => {});

    sessionStack.eventSession.on("connected", () => {
      const callInProgress = localStorage.getItem("@WEBPHONE.CALLINPROGRESS");
      const call = JSON.parse(callInProgress);
      if (call.type === "Saida") {
        setCallInProgress({
          type: call.type,
          number: call.number,
          time: `00:00:00`,
          status: call.status,
          answered_call: "SIM",
        });

        localStorage.setItem(
          "@WEBPHONE.CALLINPROGRESS",
          JSON.stringify({
            type: call.type,
            number: call.number,
            time: `00:00:00`,
            status: call.status,
            answered_call: "SIM",
          })
        );

        start();
      }
    });

    sessionStack.eventSession.on("terminated", async () => {
      /** pausando audio  */
      document.getElementById("webphone-audio").pause();
      /** Verificando se a chamada está em progresso */
      const call = JSON.parse(localStorage.getItem("@WEBPHONE.CALLINPROGRESS"));
      if (call) {
        saveContactHistories(
          call.number,
          call.status == "Receiving Call" ? "Chamada Perdida" : call.type,
          call.answered_call == "NAO" ? "00:00:00" : call.time,
          call.answered_call
        );
        localStorage.removeItem("@WEBPHONE.CALLINPROGRESS");
      }
      setShowReceivingCall(false);
      /** Efetuar inserção do código para quando a chamada for finalizada */
      setCallInProgress({
        type: "",
        number: "",
        time: "",
        status: "",
        answered_call: "",
      }); /** Efetua a limpeza da chamada em progresso assim que finalizada */
      reset();
      pause();
      setRouter("make-a-call");
    });
  };

  let startEventStackListeners = () => {
    stacking.eventStack.on("m_permission_refused", () => {
      alert("Permissão de mídia negada!");
    });

    stacking.eventStack.on("i_new_call", async (receiveCallInterface) => {
      setCallInProgress({
        type: "Entrada",
        number: receiveCallInterface.callerName,
        time: "",
        status: "Receiving Call",
        answered_call: "NAO",
      });
      localStorage.setItem(
        "@WEBPHONE.CALLINPROGRESS",
        JSON.stringify({
          type: "Entrada",
          number: receiveCallInterface.callerName,
          time: "",
          status: "Receiving Call",
          answered_call: "NAO",
        })
      );
      setInterationSIP(stacking);
      setShowReceivingCall(true);
      startEventSessionListeners();
      await document.getElementById("webphone-audio").play();
    });

    stacking.eventStack.on("stopped", async () => {
      startStack();
    });
  };

  const saveContactHistories = async (
    number,
    type,
    duraction = "00:00:00",
    answered_call = "NAO"
  ) => {
    await api.post("/contacts/histories-call", {
      cc_sip_buddies_id: 1,
      phone_number: number,
      duraction_call: duraction,
      direction_call: type,
      channel: "Telefonia",
      answered_call,
    });

    await attendantLaravelApi.post("/web-phone/activities-history", {
      channel_type: "phonenumber",
      phone_number_or_email: number,
      actions:
        type === "Saida"
          ? "Ligação Realizada"
          : type === "Entrada"
          ? "Chamada Recebida"
          : type,
      action_details: `${
        type === "Saida"
          ? "Foi efetuada uma ligação para o número: "
          : type === "Entrada"
          ? "Foi recebida uma ligação do número:"
          : "Foi recusada uma ligação do número: "
      } ${number}`,
    });
  };

  // Executa uma chamada
  const handleExecCall = async (number) => {
    console.log(number);
    activeCall = BCSIP.createAudioCall(stack, number);
    setCallInProgress({
      type: "Saida",
      number: number,
      time: "",
      status: "Progress",
      answered_call: "NAO",
    });
    startEventSessionListeners();
    activeCall.call().then(() => {
      setInterationSIP(activeCall);
    });
    setRouter("call-in-progress");
  };

  // Mutar ou Desmutar chamada
  const handleMuteCall = () => {
    interationSIP.toggleMute().then((isMuted) => {
      if (isMuted) {
        setMute(true);
      } else {
        setMute(false);
      }
    });
  };

  // Finalizar chamada
  const handleEndCall = () => {
    interationSIP.hangup().then(() => {});
  };

  return (
    <CustomThemeProvider>
      <audio id="webphone-audio" loop>
        <source src="sounds/sound-iphone-12-whatsapp.mp3" type="audio/mp3" />
      </audio>
      <Webphone>
        <Router
          handleExecCall={handleExecCall}
          handleMuteCall={handleMuteCall}
          handleEndCall={handleEndCall}
        />
      </Webphone>

      {showReceivingCall && (
        <ReceivingCall saveContactHistories={saveContactHistories} />
      )}
    </CustomThemeProvider>
  );
}

export default App;
